module.exports = __webpack_public_path__ + "static/media/syncari-404.d229cbab.png";